import { gql, TypedDocumentNode } from '@apollo/client';
import { PaymentSource } from '../../../constants';
import { PAYMENT_METHOD_FRAGMENT, PaymentMethod } from '../usePaymentMethodsQuery';

export type UpdatePaymentMethodMutationInput = {
  data: {
    type: 'payments';
    attributes: {
      source?: PaymentSource;
      cardholder_name?: string;
      encrypted_data: string;
      billing_address: {
        country_name: string;
        extended_address: string | null;
        id: string | null;
        locality: string;
        postal_code: string;
        region: string;
        street_address: string;
      };
    };
  };
};

export type UpdatePaymentMethodMutationVariables = {
  id: string;
  input: UpdatePaymentMethodMutationInput;
};

export type UpdatePaymentMethodMutation = {
  updatePaymentMethod: {
    __typename: 'RestUpdatePaymentMethod';
    data: PaymentMethod;
  };
};

export const UPDATE_PAYMENT_METHOD_MUTATION: TypedDocumentNode<
  UpdatePaymentMethodMutation,
  UpdatePaymentMethodMutationVariables
> = gql`
  mutation UpdatePaymentMethodMutation($id: String!, $input: UpdatePaymentMethodMutationInput!) {
    updatePaymentMethod(id: $id, input: $input)
      @rest(
        type: "RestUpdatePaymentMethod"
        endpoint: "moda"
        path: "/v3.5/payments/{args.id}"
        method: "PATCH"
      ) {
      data @type(name: "RestPaymentMethod") {
        ...PaymentMethodFragment
      }
    }
  }
  ${PAYMENT_METHOD_FRAGMENT}
`;
